import { Step } from "react-joyride";

/**
 * Guided tour steps for the Evaluation Criteria step.
 *
 * Each step targets a `data-testid` attribute rendered in the step.
 * If a target isn't present (e.g. add form is closed), Joyride will auto-skip it.
 */
export const evaluationCriteriaSteps: Step[] = [
	{
		target: '[data-testid="add-criterion-btn"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Add Criterion</h3>
				<p>
					Click here to add a new evaluation criterion. You&apos;ll need to
					provide a name, optional description, evaluation type, and weight.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	}, {
		target: '[data-testid="criteria-table"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Criteria Table</h3>
				<p>
					This table lists all evaluation criteria defined for this RFx.
					Each criterion has a name, description, evaluation type, and weight.
				</p>
				<p className="mt-2 text-gray-500">
					Click the edit or delete icons on any row to modify existing criteria.
				</p>
				<p className="mt-2 text-gray-500">
					Use the three dots on the left of each row to drag and reorder criteria. The order here determines the order they appear in the Panel Meeting and Scorecard.
				</p>
			</div>
		),
		placement: "bottom",
		disableBeacon: true,
	},
	{
		target: '[data-testid="weight-summary"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Weight Summary</h3>
				<p>
					The total weight across all criteria must equal exactly 100% before
					you can proceed to the next step.
				</p>
				<p className="mt-2 text-gray-500">
					The indicator turns green when the total reaches 100%.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
	{
		target: '[data-testid="criteria-search-section"]',
		content: (
			<div className="text-sm">
				<h3 className="mb-2 text-base font-semibold">Copy from Previous RFx</h3>
				<p>
					Search for criteria from a previous RFx and copy them into this
					evaluation. This saves time when using a similar set of criteria
					across projects.
				</p>
			</div>
		),
		placement: "top",
		disableBeacon: true,
	},
];
